var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 32,
    height: 32,
    rx: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-copy",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M8.338,24.669c-4.9,0-7.088-2.188-7.088-7.088V13.338c0-4.9,2.188-7.088,7.088-7.088h3.349a.837.837,0,1,1,0,1.674H8.338c-4,0-5.414,1.418-5.414,5.414V17.58c0,4,1.418,5.414,5.414,5.414H12.58c4,0,5.414-1.418,5.414-5.414V14.231a.837.837,0,1,1,1.674,0V17.58c0,4.9-2.188,7.088-7.088,7.088Z",
    transform: "translate(-1.25 -0.669)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M14.259,15.068c-3.137,0-4.409-1.273-4.409-4.409V7.087a.827.827,0,0,1,.513-.77.845.845,0,0,1,.915.179l7.144,7.144a.841.841,0,0,1,.179.915.827.827,0,0,1-.77.513Zm-2.735-4.409c0,2.221.513,2.735,2.735,2.735h1.552L11.524,9.107Z",
    transform: "translate(-0.25 -0.668)",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M11.687,2.924a.837.837,0,1,1,0-1.674h4.465a.837.837,0,1,1,0,1.674Z",
    transform: "translate(-0.134 -1.25)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M6.25,5.436A4.188,4.188,0,0,1,10.436,1.25h2.925a.837.837,0,0,1,0,1.674H10.436A2.515,2.515,0,0,0,7.924,5.436a.837.837,0,0,1-1.674,0Z",
    transform: "translate(-0.669 -1.25)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M18.44,18.134a.843.843,0,0,1,.837-.837,2.3,2.3,0,0,0,2.3-2.3V8.087a.837.837,0,1,1,1.674,0V15a3.983,3.983,0,0,1-3.974,3.974A.843.843,0,0,1,18.44,18.134Z",
    transform: "translate(0.749 -0.552)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M19.436,9.622c-2.969,0-4.186-1.217-4.186-4.186V2.087a.827.827,0,0,1,.513-.77.845.845,0,0,1,.915.179l6.7,6.7a.841.841,0,0,1,.179.915.827.827,0,0,1-.77.513ZM16.924,5.436c0,2.043.469,2.512,2.512,2.512h1.328l-3.84-3.84Z",
    transform: "translate(0.378 -1.25)",
    fill: "#15345a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.a820b5123b18cc90ffda6ebe968fbc0b.svg";
export { ForwardRef as ReactComponent };